import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatPaginator,
  PageEvent,
  MatTableDataSource,
  MatSort,
  Sort,
  MatAutocompleteTrigger,
} from "@angular/material";
import { CreateTripModalComponent } from "../dashboardModals/create-trip-modal/create-trip-modal.component";
import { HttpService } from "../http.service";
import { SnackbarService } from "../snackbar.service";
import { TranslateService } from "@ngx-translate/core";
import { TimeService } from "../time.service";
import { Subscription } from "rxjs";
import { EventService } from "../event.service";
import { ExpressDetailsComponent } from "./express-details/express-details.component";

@Component({
  selector: "app-express-shipments",
  templateUrl: "./express-shipments.component.html",
  styleUrls: ["./express-shipments.component.scss"],
})
export class ExpressShipmentsComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  pageEvent: PageEvent;

  showLoader = false;
  filter: any = "";
  selectedStatus: any; // holds the selected status (Available/Deleted)
  statusArray = [
    {
      status: "Active",
      is_deleted: false,
    },
    {
      status: "Deleted",
      is_deleted: true,
    },
  ];
  ordersArray: any = [];
  orders: any = [];
  totalOrders = 0;
  carrierId: Subscription;

  dashboardFilters: any = {
    is_deleted: false,
    limit: 0,
    skip: 0,
  };
  dataSource = new MatTableDataSource<Element>();

  columnsToDisplay = [
    "sin",
    "shipment",
    "drop_location",
    "client",
    "packages",
    "booking_date",
    "type",
    "status",
    "action",
  ];
  constructor(
    private dialog: MatDialog,
    private http: HttpService,
    private snackBar: SnackbarService,
    private time: TimeService,
    private translation: TranslateService,
    private events: EventService
  ) {}
  ngOnInit() {
    this.selectedStatus = this.statusArray[0];
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getOrders();
        const rupee = JSON.parse(localStorage.getItem("carriers"));
        //this.currencySymbol = rupee[0].country.currency.symbol;
      },
      (err: any) => {
        console.log("Err ::", err);
      }
    );
    this.getOrders();
  }

  getOrders(filters: any = {}) {
    
    this.showLoader = true;
    filters.limit = this.paginator.pageSize || 25;
    filters.skip =
      this.paginator.pageIndex * (this.paginator.pageSize || filters.limit);
    filters.is_deleted = this.selectedStatus.is_deleted;

    if (this.filter) {
      filters.dashboard_filter = this.filter;
    }
    this.http.post("express_order/get_many", filters).subscribe(
      (data: any) => {
        
        if (data.statusCode == 200) {
          this.ordersArray = data.data.orders;
          this.totalOrders = data.data.count;
          this.orders = [];

          this.ordersArray.forEach((element) => {
            const temp: any = {};
            temp._id = element._id;
            temp.selected = false;
            temp.shipment = element.OIN;
            temp.drop_location = element.delivery_locations[0].loc_id.city;
            temp.client = element.organization.name;
            let res = 0;
            element.commercial_invoice_details.filter(
              (x) => (res += x.no_of_packages)
            );
            element.commercial_invoice_details.filter(
              (x) => (res += x.weight)
            );
            temp.packages = res;
            temp.weight = res;
            temp.booking_date = element.created_at
              ? this.formatTime(element.created_at)
              : "--";
            temp.type = "express";
            temp.status = element.status;
            temp.carrier = element.carrier ? element.carrier.name : "";
            temp.pickup_locations = element.pickup_locations;
            temp.delivery_locations = element.delivery_locations;
            temp.updated_at=element.updated_at;
            temp.commercial_invoice_details=element.commercial_invoice_details;
            this.orders.push(temp);
          });

          this.showLoader = false;
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(this.orders);
            //this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant(
              "DASHBOARD.pagination_label"
            );
          } else {
            this.dataSource = new MatTableDataSource(this.orders);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant(
              "DASHBOARD.pagination_label"
            );
          }
        }
      },
      (err: any) => {
        
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
        this.paginator._intl.itemsPerPageLabel = this.translation.instant(
          "DASHBOARD.pagination_label"
        );
        if (err.error.statusCode == 401) {
          // this.valid.logout();
        }
      }
    );
  }

  pageNavigate(event: PageEvent) {
    
    this.dashboardFilters.limit = event.pageSize;
    this.dashboardFilters.skip = event.pageIndex * event.pageSize;
    this.dashboardFilters.is_deleted = this.selectedStatus.is_deleted;
    this.getOrders(this.dashboardFilters);
  }
  formatTime(time) {
    return this.time.toShortDateTime(time, "dd-MMM-yyyy");
  }

  openCreateTripModal() {
    let orderData = this.orders.filter((x) => x.selected == true);
    if(orderData.length>0){
      const dialogRef = this.dialog.open(CreateTripModalComponent, {
        data: orderData,
        width: "1250px",
        maxWidth: "95vw !important",
      });
      dialogRef.afterClosed().subscribe(result => {
        this.orders.forEach((x) => x.selected = false);
       });
    }else{
      this.snackBar.openSnackBar("please select atleast once checkbox", "", "err");
    }
    
  }
  stopProp() {}
  sortShipmentData(e) {}

  selectDriverType(event, element) {
    
    let d = this.ordersArray;
    if (event.source._selected) {
    }
  }
  openShipmentDetails(rowData) {
    const viewDialog = this.dialog.open(ExpressDetailsComponent, {
       data: rowData,
    });
    this.showLoader= false;
  }
  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
}
